import base from "./base";
import { extendTheme } from "./utils";

export default extendTheme(base, {
    primary: '#ff0000',
    primaryDark: '#ff0000',

    logoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/kfzspot-logo.png',
    smallLogoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/kfzspot-small.png',
    loadingLogoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/kfzspot-logo.png',

    availableProducts: ["Schadenmeldung", "smartKV", "Reparaturnachweis", "Zustandsbericht"],
});